import React from 'react';
import { Section } from '@ydistri/ds';
import { styled } from 'styled-components';
import AsoStoreTierSettings from './AsoStoreTierSettings/AsoStoreTierSettings';
import AsoStoreTierTable from './AsoStoreTierTable/AsoStoreTierTable';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 30rem 1fr;
  gap: 1.5rem;
  align-items: start;
`;

const AsoStoreTiers: React.FC = () => {
  return (
    <Section header="Store tiers" collapsible>
      <Wrapper>
        <AsoStoreTierSettings />
        <AsoStoreTierTable />
      </Wrapper>
    </Section>
  );
};

export default AsoStoreTiers;
